
	import {
		Vue,
		Component
	} from 'vue-property-decorator'
	import AddOrUpdate from './address-book-add-or-update'
	import AddressBookBacthIn from './address-book-bacth-in'
	import Template from "@/template.vue";
	@Component({
		name: 'contractinfo',
		components:{
			Template,
			AddOrUpdate,
			AddressBookBacthIn
		}
	})
	export default class contractinfo extends Vue {
		addressBookVisible=false
		batchVisible = false
		currentNo: number = 1;
		pageSize: number = 10;
		pageTotal: number = 0;
		searchForm= {
			sjhm:'',
			bm: '',
            gd: '',
			syr: '',
			zrr: '',
			zw: '',
			dh: ''
		}
		addressBookList=[]
		loading: boolean = false;
		dataListSelections=[];
		transferRecordsTitle = '流转记录';
		transferRecordsShow = false;
		transferRecordsList=[];
		loadingLog = false;

		created() {
			this.searchData();
		}

		searchData() {
			this.searchForm.page = this.currentNo
			this.searchForm.pagesize = this.pageSize
			this.loading = true;
			this.$request({
					url: '/bjba/addressBook/page',
					method: 'get',
					params: this.searchForm
				})
				.then(response => {
					this.loading = false;
					console.log(response);
					let data = response.data;
					if (data.code == 200) {
						this.addressBookList = data.data.content;
						this.pageTotal = data.data.totalElements
					} else {
						this.$message.error(data.message)
					}
				})
				.catch(error => {
					this.loading = false;
					console.log(error)
					this.$message.error(error)
				});
		}

		handleSizeChange(val: number) {
			this.pageSize = val;
			this.searchData();
		}
		handleCurrentChange(val: number) {
			this.currentNo = val;
			this.searchData();
		}

		changeIndex() {
			this.currentNo =1
		}
		
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}

		addOrUpdate(val: any) {
			this.addressBookVisible = true
			this.$nextTick(() => {
				this.$refs.addressbook.init(val)
			})
		}

		deleteHandle (id) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			if(!ids || ids.length==0) return
			this.$confirm(`确定进行[删除]操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/addressBook/delete`,
					method: 'post',
					data: ids
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.searchData()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}

		getTransferRecords(sjhm) {
			this.transferRecordsTitle = sjhm + '--流转记录';
			this.transferRecordsShow = true
			this.$request({
				url: '/bjba/addressBook/getTransferRecords',
				method: 'get',
				params: {sjhm: sjhm}
			})
			.then(response => {
				console.log("查询流转记录返回数据：",response);
				let data = response.data;
				if (data.code == 200) {
					this.transferRecordsList = data.data
				}
			})
			.catch(error => {
				console.log(error)
			});
		}

		batchIn() {
			console.log("点击导入")
			this.batchVisible = true
			console.log("111")
			this.$nextTick(() => {
				console.log("222")
				this.$refs.batchin.init()
			})
		}

		exportExcel() {
			console.log("点击导出")
			var viewUrl = this.$request.defaults.baseURL + '/bjba/addressBook/exportExcel?sjhm=' + this.searchForm.sjhm + '&bm=' + this.searchForm.bm + '&gd=' + this.searchForm.gd + '&syr=' + this.searchForm.syr + '&zrr=' + this.searchForm.zrr + '&zw=' + this.searchForm.zw + '&dh='+ this.searchForm.dh +'&access_token=' + this.$store.getters.token
            window.open(viewUrl)
		}
	}
